
import UIBaseComponent from "@baseUI/component/base/UIBaseComponent";
import UICreatorComponent from "@baseUI/utils/UICreatorComponent";
import UISignals from "@baseUI/controllers/UISignals";
import DynamicTextComponent from "@baseUI/component/text/DynamicTextComponent";
import UICreatorText from "@baseUI/utils/UICreatorText";
import Signals from "@baseUI/controllers/UISignals";
import Facade from "@/Facade";

export default class AutoplayCounter extends UIBaseComponent {

  constructor(nameBtn) {
    super()

    this.btnAutoplayStop = UICreatorComponent.addButton(nameBtn, this, [0, 0])
    this.btnAutoplayStop.on('tapButton', () => {
      UISignals.stopAutoplay.dispatch()
    })

  //  this.btn = UICreatorComponent.addElement('autoStopCounter_BITMAP', this, [0, -150])
   // console.log('AutoplayCounter btn!!!!!!!!!!!  ',  this.btn.width,  this.btn.height)
    this.betSlider =  UICreatorComponent.addElement('BetSlider.png', this, [ -120, 0 ],1,[0.5, 0.5])
    this.autoplayNumber = UICreatorText.addElementDynamicTextName('autoplayCounter_DYNAMIC', this.betSlider, [0, 0])

    this.onOrientationChanged(Facade.orientation)
    Signals.orientationChanged.add(this.onOrientationChanged, this)


    // Signals.setWin.add((value) => {
    //   console.log('winDynamic : ', value)
    //   this.win.text = ( value === '' ) ? 0 : value
    // })
    //
    // const autoplayNumber = new DynamicTextComponent( 'autoplayCounter_DYNAMIC', 'autoplayCounterDynamic')
    // autoplayNumber.pivot.set(0, 0);
    // autoplayNumber.y = - this.height /4;
    // this.addChild(autoplayNumber)

    // const autoplayStop = new TextComponent('autoplayStop_TEXT')
    // autoplayStop.y = this.height /4;
    // this.addChild(autoplayStop)
  }

  set count(value){
    this.autoplayNumber.text = value
  }

  set betSliderVisible(value){
    this.betSlider.visible = value
  }

  onOrientationChanged(orientationSymbol) {
    switch ( orientationSymbol ) {
      case 'Hd':
        this.betSlider.position.set(-120, 0)
        break;
      case 'Hm':
        this.betSlider.position.set(0, -150)
        break
      case 'Vm':
        this.betSlider.position.set(0, -150)
        break
    }
  }


  disable() {
    this.btnAutoplayStop.disable()
  }

  enable() {
    this.btnAutoplayStop.enable()
  }

}